import type { IconDef } from '../types';

export const info: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M12 0C18.6218 0 24 5.37818 24 12C24 18.6218 18.6218 24 12 24C5.37818 24 0 18.6218 0 12C1.93648e-07 5.37818 5.37818 1.93642e-07 12 0ZM17.1816 3.66504C12.9271 1.0144 7.14522 2.59667 4.28711 7.2002C1.4291 11.8038 2.56388 17.695 6.81836 20.335C11.0729 22.9747 16.8548 21.3817 19.7129 16.7891V16.7998C22.5709 12.1962 21.4361 6.305 17.1816 3.66504ZM12 9.81836C12.6 9.81836 13.0908 10.3092 13.0908 10.9092V17.0068C13.0908 17.6068 12.6 18.0986 12 18.0986C11.4 18.0986 10.9092 17.6068 10.9092 17.0068V10.9092C10.9092 10.3092 11.4 9.81836 12 9.81836ZM11.0381 6.6377C11.3545 5.77613 12.1511 5.27486 12.8164 5.51465L12.8057 5.52539C13.482 5.76537 13.7655 6.65973 13.4492 7.52148C13.1329 8.3833 12.3364 8.88551 11.6709 8.64551C11.0056 8.39446 10.7218 7.4994 11.0381 6.6377Z',
    },
  ],
};
